import React from "react";
import * as styles from "./Collage.module.css";
import { ComponentProps } from "../../../types";
import {
  SummaryTile,
  SummaryTileProps,
} from "../../elements/SummaryTile/SummaryTile";
import { SectionWrapper } from "../../containers/SectionWrapper";

interface Props extends ComponentProps {
  summaries: SummaryTileProps[];
  displayImages?: boolean;
}

export const Collage: React.FC<Props> = ({
  summaries,
  displayImages,
  ...props
}) => {
  return (
    <SectionWrapper {...props}>
      <div className={styles.newslisting}>
        <div className={styles.grid}>
          {summaries?.map((tile, idx) => {
            let bgPosition = null;
            if (idx === 0) {
              bgPosition = "top";
            }
            if (idx === 1) {
              bgPosition = "right";
            }

            return (
              <SummaryTile
                key={idx}
                {...tile}
                bgPosition={bgPosition}
                tileWidth="oneThird"
                clickableTile={true}
                className={styles.collageSummary}
                displayImages={displayImages}
              />
            );
          })}
        </div>
      </div>
    </SectionWrapper>
  );
};
